import { StyledFieldSet, StyledLegend, StyledSpan } from '../../../../../components/StyledElements'
import i18n from 'simple-react-i18n'
import Input from '../../../../../components/forms/Input'
import { hasValue } from '../../../../../utils/NumberUtil'
import StationImportCodeMessage from '../../../../../import/components/utils/StationImportCodeMessage'
import React from 'react'
import Select from '../../../../../components/forms/Select'
import { shallowEqual, useSelector } from 'react-redux'
import { Grid } from '@mui/material'


const AddQualitoStepOptionsEmpty = ({
    station,
    changeStation,
}) => {
    const {
        cities,
    } = useSelector(store => ({
        cities: store.CityReducer.cities,
    }), shallowEqual)

    return (
        <StyledFieldSet>
            <StyledLegend>
                <StyledSpan>{i18n.options}</StyledSpan>
            </StyledLegend>
            <div>
                <Grid container spacing={1} sx={{ paddingTop: 2 }}>
                    <Grid size={3}>
                        <Input value={station.code} onChange={v => changeStation({ code: v })} title={i18n.code} noSpace/>
                    </Grid>
                    <Grid size={5}>
                        <Input value={station.name} onChange={v => changeStation({ name: v })} title={i18n.name}/>
                    </Grid>
                    <Grid size={4}>
                        <Select value={station.townCode} options={cities} onChange={v => changeStation({ townCode: v })} label={i18n.city}/>
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid size={12}>
                        { hasValue(station.code) && <StationImportCodeMessage code={station.code} stationType='quality'/> }
                    </Grid>
                </Grid>
            </div>
        </StyledFieldSet>
    )
}

AddQualitoStepOptionsEmpty.propTypes = {
}

export default AddQualitoStepOptionsEmpty